/** 1-based "Record number 10" caption for the preview card subtitle. */
export function formatFieldPreviewRowLabel(rowIndex, rowTotal) {
    const total = Number(rowTotal) || 0;
    if (total < 1) return null;
    const row = Math.min(Math.max((Number(rowIndex) || 0) + 1, 1), total);
    return `Record number ${row.toLocaleString('en-US')}`;
}

/** Modal subtitle: "Record number 10 · from column Example". */
export function formatFieldPreviewModalSubtitle(rowIndex, rowTotal, columnName) {
    const row = formatFieldPreviewRowLabel(rowIndex, rowTotal);
    const fromColumn = columnName ? `from column ${columnName}` : null;
    return [row, fromColumn].filter(Boolean).join(' · ');
}
